const initPriceFilter = () => {

    const rangeInput = document.querySelectorAll(".range-input input"),
    priceInput = document.querySelectorAll(".price-input input");
    // range = document.querySelector(".slider .progress");
    let priceGap = 5;
    
    priceInput.forEach(input =>{
        input.addEventListener("input", e =>{
          var range = e.target.closest('.wrapper-price-range').querySelector('.progress')
          console.log(range)
          console.log('hey')
            let minPrice = parseInt(priceInput[0].value),
            maxPrice = parseInt(priceInput[1].value);
            
            if((maxPrice - minPrice >= priceGap) && maxPrice <= rangeInput[1].max){
                if(e.target.className === "input-min"){
                    rangeInput[0].value = minPrice;
                    range.style.left = ((minPrice / rangeInput[0].max) * 100) + "%";
                } else {
                    rangeInput[1].value = maxPrice;
                    range.style.right = 100 - (maxPrice / rangeInput[1].max) * 100 + "%";
                }
            }
        });
    });
    
    rangeInput.forEach(input =>{
        input.addEventListener("input", e =>{
          var target = e.target
          var range = e.target.closest('.wrapper-price-range').querySelector('.progress')
          var parent = e.target.closest('.wrapper-price-range')
          var isMobile = parent.classList.contains('mobile__price_range')
          var minInput = parent.querySelector('.range-min')
          var maxInput = parent.querySelector('.range-max')
          let minVal = parseInt(minInput.value),
          maxVal = parseInt(maxInput.value);
            const minlist = parent.querySelector(".min-flex-item");
                minlist.innerHTML = minVal + ".00";
        
                const maxlist = parent.querySelector(".max-flex-item");
                maxlist.innerHTML = maxVal + ".00";
            
            if((maxVal - minVal) < priceGap){
                
                if(e.target.className === "range-min"){
                    minInput.value = maxVal - priceGap
                }else{
                    maxInput.value = minVal + priceGap;
                }
            }else{
              console.log(isMobile)
              if (isMobile) {
                priceInput[2].value = minVal;
                priceInput[3].value = maxVal;
              } else {
                priceInput[0].value = minVal;
                priceInput[1].value = maxVal;
              }
                range.style.left = ((minVal / minInput.max) * 100) + "%";
                range.style.right = 100 - (maxVal / maxInput.max) * 100 + "%";
            }
        });
    });
     
}



initPriceFilter()

document.addEventListener('filtersReint', () =>{
    initPriceFilter()
})